module.exports = __webpack_public_path__ + "img/sticker-normal.622d13b2.svg";